import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_BASE } from "./config";
import { connectSocket } from '../socket/socket';
import '../css/Login.css';

function Login() {
  const [form, setForm] = useState({ name: '', password: '' });
  const [lineStarting, setLineStarting] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const startLineLogin = async () => {
    try {
      setLineStarting(true);
      const response = await fetch(`${API_BASE}/api/users/line/config`);
      const data = await response.json().catch(() => ({}));
      if (!response.ok || !data.enabled) {
        throw new Error(
          'ยังไม่ได้ตั้งค่า LINE Login กรุณาเพิ่ม LINE Channel ID และ Secret ที่ Server'
        );
      }
      window.location.assign(`${API_BASE}/api/users/line/login`);
    } catch (error) {
      alert(error.message || 'เริ่ม LINE Login ไม่สำเร็จ');
      setLineStarting(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const res = await fetch(`${API_BASE}/api/users/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(form)
    });

    const data = await res.json();

    if (!res.ok) {
      alert(data.message);
      return;
    }

    localStorage.setItem('token', data.token);
    localStorage.setItem('user', JSON.stringify(data.user));
    connectSocket(data.token);

    if (data.user.role === 'admin') {
      navigate('/dashboard');
    } else {
      navigate('/profile');
    }
  };

  return (
    <div className="login-container">

      <div className="login-card">

        <div className="login-logo">🏸</div>
        <h2>BADMINTON SPORT</h2>
        <p className="login-sub">เข้าสู่ระบบเพื่อเริ่มการแข่งขัน</p>

        <form onSubmit={handleSubmit} className="login-form">

          <div className="input-group">
            <label>ชื่อผู้เล่น</label>
            <input
              name="name"
              placeholder="กรอกชื่อของคุณ"
              onChange={handleChange}
              required
            />
          </div>

          <div className="input-group">
            <label>รหัสผ่าน</label>
            <input
              type="password"
              name="password"
              placeholder="กรอกรหัสผ่าน"
              onChange={handleChange}
              required
            />
          </div>

          <button className="login-btn">เข้าสู่ระบบ</button>

        </form>

        <div className="login-divider"><span>หรือ</span></div>
        <button
          type="button"
          className="line-login-btn"
          disabled={lineStarting}
          onClick={startLineLogin}
        >
          <span className="line-login-mark" aria-hidden="true">LINE</span>
          {lineStarting ? 'กำลังเปิด LINE…' : 'เข้าสู่ระบบด้วย LINE'}
        </button>

  <p className="register-link">
    ยังไม่มีบัญชี? 
    <span onClick={() => navigate('/register')}>
      สมัครสมาชิก
    </span>
  </p>
      </div>

    </div>
  );
}

export default Login;
